import React, { FC } from 'react';
import styled from 'styled-components';
import { globalTheme } from '@clds/component-theme';
import ReactSlider from './ReactSlider';
import Drag from './components/Trim/TrimDrag';
import Handler from './components/Trim/TrimHandler';
import Track from './components/Trim/TrimTrack';
import { isMarkedTrack } from './helpers/isMarkedTrack';
import { SliderProps } from './props';

const Root = styled.div`
  background-color: ${globalTheme.palette.secondary};
  height: 1rem;
  width: 100%;
  border-radius: 100px;
`;

const SliderTrim: FC<SliderProps> = ({ showTooltip, tooltipPlacement, renderValue, ...props }) => (
  <Root>
    <ReactSlider
      {...props}
      allowTrim
      renderTrack={(props, state) => (state && isMarkedTrack(state) ? <Drag selected {...props} /> : <Track {...props} />)}
      renderThumb={(props, state) => {
        const value = renderValue ? renderValue(props, state) : state.valueNow;
        return <Handler
          {...{ showTooltip, tooltipPlacement, ...props }}
          value={value}
          data-test-label={value}
          direction={state && isMarkedTrack(state) ? 'left' : 'right'}
               />;
      }}
    />
  </Root>
);

export default SliderTrim;
